import axios from 'axios';

// export const nombre_empresa = "Local DEV";
// export const API_URL = 'http://127.0.0.1:8000/api';
// export const API_UR = 'http://127.0.0.1:8000';
// export const url_firma = 'http://localhost:3000';

// export const nombre_empresa = "Remanufacturado";
// export const API_URL = 'https://apiremanufacturado.maxicomm.com.mx/api';
// export const API_UR = 'https://apiremanufacturado.maxicomm.com.mx';
// export const url_firma = 'https://remanufacturado.maxicomm.com.mx';

export const nombre_empresa = "MAX PC DE MEXICO";
export const API_URL = 'https://api.maxicomm.com.mx/api';
export const API_UR = 'https://api.maxicomm.com.mx';
export const url_firma = 'https://sistema.maxicomm.com.mx';

// export const nombre_empresa = "NETS TECNOLOGIA";
// export const API_URL = 'https://apinets.maxicomm.com.mx/api';
// export const API_UR = 'https://apinets.maxicomm.com.mx';
// export const url_firma = 'https://nets.maxicomm.com.mx';





//  export const API_URL = 'https://apicontpaq.maxicomm.com.mx/api';
// export const API_UR = 'https://apicontpaq.maxicomm.com.mx';
//npm install --global --production windows-build-tools




  /*importacion de bd del servidor a local

  cd /xampp\mysql\bin     
  mysql -h localhost -u root -p 
  **ingresas password
  use bdname ;
  source filename.sql

  el archivo filename.sql tiene que estar en la carpeta bin


  drop database coti;
  create database coti;
  use coti;
  source coti.sql;

  */


 
export const request = axios.create({
	baseURL 		: API_UR,
	responseType 	: 'json'
});

export const api = () => {

	let token = localStorage.getItem('session_token_maxicom');

	token = JSON.parse(token);

	let AuthorizationToken = token.token_type+" "+token.access_token;

	return axios.create({
		baseURL 		: API_URL,
		responseType 	: 'json',
		headers 		: {'Authorization': AuthorizationToken },
		config: {
        headers: {
         'Access-Control-Allow-Origin': '*',
       }
   }

	});

}
export const api_formdata = () => {

	let token = localStorage.getItem('session_token_maxicom');

	token = JSON.parse(token);

	let AuthorizationToken = token.token_type+" "+token.access_token;

	return axios.create({
		baseURL 		: API_URL,
		responseType 	: 'json',
		headers 		: {'Authorization': AuthorizationToken,'Content-Type': 'multipart/form-data', }

	});

}

export const api_descarga = () => {
	let token = localStorage.getItem('session_token_maxicom');
	token = JSON.parse(token);
	let AuthorizationToken = token.token_type+" "+token.access_token;
	return axios.create({
		baseURL 		: API_URL,
		responseType 	: 'blob',
		headers 		: {'Authorization': AuthorizationToken,
									 'Content-Type': 'multipart/form-data', }
	});
}


// WEBPACK FOOTER //
// ./src/actions/_request.js